import {
  //
  ADD_ACTION,
  ADD_ACTION_FAILURE,
  ADD_ACTION_SUCCESS,
  //
  EDIT_ACTION,
  EDIT_ACTION_SUCCESS,
  EDIT_ACTION_FAILURE,
  //
  ADD_ITEM,
  ADD_ITEM_FAILURE,
  ADD_ITEM_SUCCESS,
  //
  ADD_OUTCOME,
  ADD_OUTCOME_FAILURE,
  ADD_OUTCOME_SUCCESS,
  //
  ADD_SURVEY,
  ADD_SURVEY_FAILURE,
  ADD_SURVEY_SUCCESS,
  //
  DELETE_ACTION,
  DELETE_ACTION_FAILURE,
  DELETE_ACTION_SUCCESS,
  //
  DELETE_SURVEY,
  DELETE_SURVEY_FAILURE,
  DELETE_SURVEY_SUCCESS,
  //
  EDIT_SURVEY,
  EDIT_SURVEY_FAILURE,
  EDIT_SURVEY_SUCCESS,
  //
  FETCH_INVITEES,
  FETCH_INVITEES_FAILURE,
  FETCH_INVITEES_SUCCESS,
  //
  FETCH_RESPONSES,
  FETCH_RESPONSES_FAILURE,
  FETCH_RESPONSES_SUCCESS,
  //
  FETCH_SURVEYS,
  FETCH_SURVEYS_FAILURE,
  FETCH_SURVEYS_SUCCESS,
  //
  GENERATE_QR,
  GENERATE_QR_FAILURE,
  GENERATE_QR_SUCCESS,
  //
  GET_ACTIONS,
  GET_ACTIONS_FAILURE,
  GET_ACTIONS_SUCCESS,
  //
  GET_DASHBOAD,
  GET_DASHBOAD_FAILURE,
  GET_DASHBOAD_SUCCESS,
  //
  GET_HEADLINES,
  GET_HEADLINES_FAILURE,
  GET_HEADLINES_SUCCESS,
  //
  GET_JSON,
  GET_JSON_FAILURE,
  GET_JSON_SUCCESS,
  //
  GET_OVERVIEW,
  GET_OVERVIEW_FAILURE,
  GET_OVERVIEW_SUCCESS,
  //
  GET_PLAN,
  GET_PLAN_FAILURE,
  GET_PLAN_SUCCESS,
  //
  GET_RESPONSE,
  GET_RESPONSE_FAILURE,
  GET_RESPONSE_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  INVITE,
  INVITE_FAILURE,
  INVITE_SUCCESS,
  //
  SEARCH_SURVEY,
  SEARCH_SURVEY_FAILURE,
  SEARCH_SURVEY_SUCCESS,
  SET_DASH_YEAR,
  //
  SET_YEAR,
  //
  TOGGLE_ACTION_MODAL,
  //
  TOGGLE_INVITE_MODAL,
  TOGGLE_ITEM_MODAL,
  TOGGLE_OUTCOME_MODAL,
  TOGGLE_QUE_MODAL,
  TOGGLE_INVEMP_MODAL,
  UPDATE_JSON,
  TOGGLE_DELETE,
  TOGGLE_COMMENT,
  TOGGLE_FINDING_COMMENT,
  //
  EDIT_OUTCOME,
  EDIT_OUTCOME_SUCCESS,
  EDIT_OUTCOME_FAILURE,
  //
  DELETE_PLAN,
  DELETE_PLAN_SUCCESS,
  DELETE_PLAN_FAILURE,
  //
  EDIT_ITEM,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEM_FAILURE,
  //
  PRINT_PLAN,
  PRINT_PLAN_SUCCESS,
  PRINT_PLAN_FAILURE,
  //
  EXPORT_SURVEY,
  EXPORT_SURVEY_SUCCESS,
  EXPORT_SURVEY_FAILURE,
  //
  GET_FINDING_REPORT,
  GET_FINDING_REPORT_SUCCESS,
  GET_FINDING_REPORT_FAILURE,
  //
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  //
  FETCH_ANALYTICS,
  FETCH_ANALYTICS_SUCCESS,
  FETCH_ANALYTICS_FAILURE,
  //
  UPDATE_SUMMARY,
  UPDATE_SUMMARY_SUCCESS,
  UPDATE_SUMMARY_FAILURE,
} from "./constants";

// List
export const fetchSurveys = (payload) => ({
  type: FETCH_SURVEYS,
  payload,
});
export const fetchSurveysSuccess = (payload) => ({
  type: FETCH_SURVEYS_SUCCESS,
  payload,
});
export const fetchSurveysFailure = (payload) => ({
  type: FETCH_SURVEYS_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onGetSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onGetSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addSurvey = (payload, history) => ({
  type: ADD_SURVEY,
  payload,
  history,
});
export const addSurveySuccess = (payload) => ({
  type: ADD_SURVEY_SUCCESS,
  payload,
});
export const addSurveyFailure = (payload) => ({
  type: ADD_SURVEY_FAILURE,
  payload,
});
// EDIT
export const editSurvey = (payload) => ({
  type: EDIT_SURVEY,
  payload,
});
export const editSurveySuccess = (payload) => ({
  type: EDIT_SURVEY_SUCCESS,
  payload,
});
export const editSurveyFailure = (payload) => ({
  type: EDIT_SURVEY_FAILURE,
  payload,
});
// DELETE
export const deleteSurvey = (payload, onDelete) => ({
  type: DELETE_SURVEY,
  payload,
  onDelete,
});
export const deleteSurveySuccess = (payload) => ({
  type: DELETE_SURVEY_SUCCESS,
  payload,
});
export const deleteSurveyFailure = (payload) => ({
  type: DELETE_SURVEY_FAILURE,
  payload,
});
export const toggleInviteModal = (payload) => ({
  type: TOGGLE_INVITE_MODAL,
  payload,
});
export const toggleQueModal = (payload) => ({
  type: TOGGLE_QUE_MODAL,
  payload,
});

// DELETE
export const invite = (payload, onInvite) => ({
  type: INVITE,
  payload,
  onInvite,
});
export const inviteSuccess = (payload) => ({
  type: INVITE_SUCCESS,
  payload,
});
export const inviteFailure = (payload) => ({
  type: INVITE_FAILURE,
  payload,
});
export const setYear = (payload) => ({
  type: SET_YEAR,
  payload,
});
export const setDashYear = (payload) => ({
  type: SET_DASH_YEAR,
  payload,
});

// QR
export const generateQR = (payload, onSuccess) => ({
  type: GENERATE_QR,
  payload,
  onSuccess,
});
export const generateQRSuccess = (payload) => ({
  type: GENERATE_QR_SUCCESS,
  payload,
});
export const generateQRFailure = (payload) => ({
  type: GENERATE_QR_FAILURE,
  payload,
});

// QR
export const fetchInvitees = (payload) => ({
  type: FETCH_INVITEES,
  payload,
});
export const fetchInviteesSuccess = (payload) => ({
  type: FETCH_INVITEES_SUCCESS,
  payload,
});
export const fetchInviteesFailure = (payload) => ({
  type: FETCH_INVITEES_FAILURE,
  payload,
});

//
export const fetchResponses = (payload) => ({
  type: FETCH_RESPONSES,
  payload,
});
export const fetchResponsesSuccess = (payload) => ({
  type: FETCH_RESPONSES_SUCCESS,
  payload,
});
export const fetchResponsesFailure = (payload) => ({
  type: FETCH_RESPONSES_FAILURE,
  payload,
});

export const getResponse = (payload) => ({
  type: GET_RESPONSE,
  payload,
});
export const getResponseSuccess = (payload) => ({
  type: GET_RESPONSE_SUCCESS,
  payload,
});
export const getResponseFailure = (payload) => ({
  type: GET_RESPONSE_FAILURE,
  payload,
});

export const getDashboard = (payload) => ({
  type: GET_DASHBOAD,
  payload,
});
export const getDashboardSuccess = (payload) => ({
  type: GET_DASHBOAD_SUCCESS,
  payload,
});
export const getDashboardFailure = (payload) => ({
  type: GET_DASHBOAD_FAILURE,
  payload,
});

export const getOverview = (payload) => ({
  type: GET_OVERVIEW,
  payload,
});
export const getOverviewSuccess = (payload) => ({
  type: GET_OVERVIEW_SUCCESS,
  payload,
});
export const getOverviewFailure = (payload) => ({
  type: GET_OVERVIEW_FAILURE,
  payload,
});

export const getHeadlines = (payload) => ({
  type: GET_HEADLINES,
  payload,
});
export const getHeadlinesSuccess = (payload) => ({
  type: GET_HEADLINES_SUCCESS,
  payload,
});
export const getHeadlinesFailure = (payload) => ({
  type: GET_HEADLINES_FAILURE,
  payload,
});

export const getJson = (payload) => ({
  type: GET_JSON,
  payload,
});
export const getJsonSuccess = (payload) => ({
  type: GET_JSON_SUCCESS,
  payload,
});
export const getJsonFailure = (payload) => ({
  type: GET_JSON_FAILURE,
  payload,
});
export const updateJson = (payload) => ({
  type: UPDATE_JSON,
  payload,
});

export const searchSurvey = (payload, onSearchSuccess) => ({
  type: SEARCH_SURVEY,
  payload,
  onSearchSuccess,
});
export const searchSurveySuccess = (payload) => ({
  type: SEARCH_SURVEY_SUCCESS,
  payload,
});
export const searchSurveyFailure = (payload) => ({
  type: SEARCH_SURVEY_FAILURE,
  payload,
});

export const getActions = (payload, onAddSuccess) => ({
  type: GET_ACTIONS,
  payload,
  onAddSuccess,
});
export const getActionsSuccess = (payload) => ({
  type: GET_ACTIONS_SUCCESS,
  payload,
});
export const getActionsFailure = (payload) => ({
  type: GET_ACTIONS_FAILURE,
  payload,
});

export const toggleActionModal = (payload) => ({
  type: TOGGLE_ACTION_MODAL,
  payload,
});

export const addAction = (payload, onAddSuccess) => ({
  type: ADD_ACTION,
  payload,
  onAddSuccess,
});
export const addActionSuccess = (payload) => ({
  type: ADD_ACTION_SUCCESS,
  payload,
});
export const addActionFailure = (payload) => ({
  type: ADD_ACTION_FAILURE,
  payload,
});

export const editAction = (payload, onEditSuccess) => ({
  type: EDIT_ACTION,
  payload,
  onEditSuccess,
});
export const editActionSuccess = (payload) => ({
  type: EDIT_ACTION_SUCCESS,
  payload,
});
export const editActionFailure = (payload) => ({
  type: EDIT_ACTION_FAILURE,
  payload,
});

export const deleteAction = (payload) => ({
  type: DELETE_ACTION,
  payload,
});
export const deleteActionSuccess = (payload) => ({
  type: DELETE_ACTION_SUCCESS,
  payload,
});
export const deleteActionFailure = (payload) => ({
  type: DELETE_ACTION_FAILURE,
  payload,
});

export const addItem = (payload, onItemAdd) => ({
  type: ADD_ITEM,
  payload,
  onItemAdd,
});
export const addItemSuccess = (payload) => ({
  type: ADD_ITEM_SUCCESS,
  payload,
});
export const addItemFailure = (payload) => ({
  type: ADD_ITEM_FAILURE,
  payload,
});

export const toggleItemModal = (payload) => ({
  type: TOGGLE_ITEM_MODAL,
  payload,
});

export const toggleOutcomeModal = (payload) => ({
  type: TOGGLE_OUTCOME_MODAL,
  payload,
});

export const addOutcome = (payload, onAddOutcome) => ({
  type: ADD_OUTCOME,
  payload,
  onAddOutcome,
});
export const addOutcomeSuccess = (payload) => ({
  type: ADD_OUTCOME_SUCCESS,
  payload,
});
export const addOutcomeFailure = (payload) => ({
  type: ADD_OUTCOME_FAILURE,
  payload,
});

export const editOutcome = (payload, onEditOutcome) => ({
  type: EDIT_OUTCOME,
  payload,
  onEditOutcome,
});
export const editOutcomeSuccess = (payload) => ({
  type: EDIT_OUTCOME_SUCCESS,
  payload,
});
export const editOutcomeFailure = (payload) => ({
  type: EDIT_OUTCOME_FAILURE,
  payload,
});

export const getPlan = (payload) => ({
  type: GET_PLAN,
  payload,
});
export const getPlanSuccess = (payload) => ({
  type: GET_PLAN_SUCCESS,
  payload,
});
export const getPlanFailure = (payload) => ({
  type: GET_PLAN_FAILURE,
  payload,
});

//
export const toggleDelete = (payload) => ({
  type: TOGGLE_DELETE,
  payload,
});

//
export const deletePlan = (payload, onDelete) => ({
  type: DELETE_PLAN,
  payload,
  onDelete,
});
export const deletePlanSuccess = (payload) => ({
  type: DELETE_PLAN_SUCCESS,
  payload,
});
export const deletePlanFailure = (payload) => ({
  type: DELETE_PLAN_FAILURE,
  payload,
});

//
export const editItem = (payload, onItemEdit) => ({
  type: EDIT_ITEM,
  payload,
  onItemEdit,
});
export const editItemSuccess = (payload) => ({
  type: EDIT_ITEM_SUCCESS,
  payload,
});
export const editItemFailure = (payload) => ({
  type: EDIT_ITEM_FAILURE,
  payload,
});

//
export const printPlan = (payload) => ({
  type: PRINT_PLAN,
  payload,
});
export const printPlanSuccess = (payload) => ({
  type: PRINT_PLAN_SUCCESS,
  payload,
});
export const printPlanFailure = (payload) => ({
  type: PRINT_PLAN_FAILURE,
  payload,
});

//
export const exportSurvey = (payload) => ({
  type: EXPORT_SURVEY,
  payload,
});
export const exportSurveySuccess = (payload) => ({
  type: EXPORT_SURVEY_SUCCESS,
  payload,
});
export const exportSurveyFailure = (payload) => ({
  type: EXPORT_SURVEY_FAILURE,
  payload,
});
//
export const toggleComment = (payload) => ({
  type: TOGGLE_COMMENT,
  payload,
});
export const toggleFindingComment = (payload) => ({
  type: TOGGLE_FINDING_COMMENT,
  payload,
});

//
export const toggleInviteEmpModal = (payload) => ({
  type: TOGGLE_INVEMP_MODAL,
  payload,
});

export const getFindingReport = (payload) => ({
  type: GET_FINDING_REPORT,
  payload,
});
export const getFindingReportSuccess = (payload) => ({
  type: GET_FINDING_REPORT_SUCCESS,
  payload,
});
export const getFindingReportFailure = (payload) => ({
  type: GET_FINDING_REPORT_FAILURE,
  payload,
});

export const fetchTemplates = (payload, onSuccess) => ({
  type: FETCH_TEMPLATES,
  payload,
  onSuccess,
});
export const fetchTemplatesSuccess = (payload) => ({
  type: FETCH_TEMPLATES_SUCCESS,
  payload,
});
export const fetchTemplatesFailure = (payload) => ({
  type: FETCH_TEMPLATES_FAILURE,
  payload,
});

export const fetchAnalytics = (payload, onSuccess) => ({
  type: FETCH_ANALYTICS,
  payload,
  onSuccess,
});
export const fetchAnalyticsSuccess = (payload) => ({
  type: FETCH_ANALYTICS_SUCCESS,
  payload,
});
export const fetchAnalyticsFailure = (payload) => ({
  type: FETCH_ANALYTICS_FAILURE,
  payload,
});

export const updateSummary = (payload, onUpdate) => ({
  type: UPDATE_SUMMARY,
  payload,
  onUpdate,
});
export const updateSummarySuccess = (payload) => ({
  type: UPDATE_SUMMARY_SUCCESS,
  payload,
});
export const updateSummaryFailure = (payload) => ({
  type: UPDATE_SUMMARY_FAILURE,
  payload,
});
